import {DnType} from 'desktop/types/checkoutItemsType';

/**
 * returns dn value for an eye
 */
export const getDnForEye = (dn: Optional<DnType>, eye: 'right' | 'left') => {
    if (!dn) return 'None';

    return dn.singular === 'None' ? dn[eye] : dn.singular;
};
